import api from '../../services/service_zone'
import Swal from 'sweetalert2'
import Pagination from 'vue-pagination-2'
import moment from 'moment'

export default {
  components: {
    Pagination
  },
  data () {
    return {
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      },
      search: '',
      zone_list: [],
      zone: '',
      activePage: 1,
      allItem: 0,
      ItemPerpage: 10,
      zone_modal: {
        zone_id: null,
        zone_name: null,
        zone_code: null
      }
    }
  },
  created () {
    this.checkUser()
  },
  methods: {
    callback: function (page) {
      this.activePage = page
      this.getZoneAll()
    },
    getZoneAll () {
      var obj = {
        search: this.search,
        active_page: this.activePage,
        per_page: this.ItemPerpage
      }
      api.getZone(obj, this.header,
        result => {
          if (result.response === true) {
            this.zone_list = result.data.pagination
            this.allItem = result.data.count
          } else {
            Swal.fire('ดึงข้อมูลโซนหมู่บ้าน', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    modalZone (zone) {
      if (zone) {
        this.zone_modal = zone
      }
      // eslint-disable-next-line no-undef
      $('#FormZone').modal('show')
    },
    clearModalZone () {
      this.zone_modal = {
        zone_id: null,
        zone_name: null,
        zone_code: null
      }
      // eslint-disable-next-line no-undef
      $('#FormZone').modal('hide')
      this.getZoneAll()
    },
    actionZone () {
      if (this.zone_modal.zone_id) {
        this.updateZone()
      } else {
        this.newZone()
      }
    },
    newZone () {
      if (this.zone_modal.zone_id !== '') {
        var obj = {
          zone_code: this.zone_modal.zone_code,
          zone_name: this.zone_modal.zone_name
        }
        this.$store.state.isLoading = true
        api.addZone(
          obj,
          this.header,
          result => {
            if (result.response === true) {
              this.getZoneAll()
              this.clearModalZone()
              Swal.fire('เพิ่มข้อมูลโซนหมู่บ้าน', result.data, 'success')
            } else {
              this.clearModalZone()
              Swal.fire('เพิ่มข้อมูลโซนหมู่บ้าน', result.data, 'warning')
            }
            this.$store.state.isLoading = false
          },
          error => {
            alert(JSON.stringify(error))
            this.$store.state.isLoading = false
          }
        )
        // eslint-disable-next-line no-undef
        $('#FormZone').modal('hide')
      } else {
        Swal.fire('แจ้งเตือน', 'กรุณาเลือกโซนที่บ้านตั้งอยู่', 'warning')
      }
    },
    updateZone () {
      // eslint-disable-next-line no-undef
      $('#FormZone').modal('hide')
      var obj = {
        zone_id: this.zone_modal.zone_id,
        zone_code: this.zone_modal.zone_code,
        zone_name: this.zone_modal.zone_name
      }
      this.$store.state.isLoading = true
      api.editZone(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.getZoneAll()
            this.clearModalZone()
            Swal.fire('แก้ไขข้อมูลโซนหมู่บ้าน', result.data, 'success')
          } else {
            Swal.fire('ดึงข้อมูลโซนหมู่บ้าน', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    removeZone (data) {
      Swal.fire({
        title: 'ลบข้อมูลโซนหมู่บ้าน?',
        text: 'ท่านต้องการลบข้อมูลโซนหมู่บ้าน' + data.zone_name + ' ใช่หรือไม่ ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.$store.state.isLoading = true
          api.deleteZone(
            data.zone_id,
            this.header,
            result => {
              if (result.response === true) {
                this.getZoneAll()
                Swal.fire('ลบข้อมูลโซนหมู่บ้าน', 'ลบข้อมูลโซนหมู่บ้านเรียบร้อยแล้ว', 'success')
              } else {
                Swal.fire('ดึงข้อมูลโซนหมู่บ้าน', result.message, 'warning')
              }
              this.$store.state.isLoading = false
            },
            error => {
              alert(JSON.stringify(error))
              this.$store.state.isLoading = false
            }
          )
        }
      })
    }
  },
  mounted () {
    moment.locale('th')
    this.getZoneAll()
    // eslint-disable-next-line no-undef
    $('body').on('hidden.bs.modal', '.modal', function () {
    // eslint-disable-next-line no-undef
      $(this).removeData('bs.modal')
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/zone.js